import { getInterface } from '@/utils/js/initVariable';
const prefixUrl = 'api/UserWorkspaceDataApi/';
export const getCameraByRegion = (data)=>{
  return getInterface.post(`${prefixUrl}getCameraByRegion`, data);
}
export const queryAnnotation = (data)=>{
  return getInterface.post(`${prefixUrl}queryAnnotation/${data}`, data);
}
export const queryRegionFeatureList = (data)=>{
  return getInterface.post(`${prefixUrl}queryRegionFeatureList`, data);
}
export const getExposurePolygonByRegionAndDate = (data)=>{
  return getInterface.post(`${prefixUrl}getExposurePolygonByRegionAndDate`, data);
}
export const getShootingLocationVideo = (data)=>{
  return getInterface.post(`${prefixUrl}getShootingLocationVideo/${data}`, data);
}
export const saveAnnotation = (data)=>{
  return getInterface.post(`${prefixUrl}saveAnnotation`, data);
}
// 工作台 新增区域数据
export const saveAnnotationGroup = (data)=>{
  return getInterface.post(`${prefixUrl}saveAnnotationGroup`, data);
}
// 上传区域视频
export const uploadShootingLocationVideo = (data)=>{
  return getInterface.postForm(`${prefixUrl}uploadShootingLocationVideo`, data);
}
// 获取区域视频
export const getAuthLink = (data)=>{
  return getInterface.postForm(`${prefixUrl}getAuthLink/${data}`, data);
}
// 删除前置标注
export const deleteAnnotation = (data)=>{
  return getInterface.postForm(`${prefixUrl}deleteAnnotation/${data}`, data);
}
// Home 导航栏 位置Com List
export const queryUserCustomLocationList = (data)=>{
  return getInterface.post(`${prefixUrl}queryUserCustomLocationList`, data);
}
export const queryUserCustomLocationList1 = (data)=>{
  return getInterface.post(`${prefixUrl}queryUserCustomLocationList1`, data);
}
// Home 导航栏 影像 List
export const queryAreaImagePageList = (data)=>{
  return getInterface.post(`${prefixUrl}queryAreaImagePageList`, data);
}
// Home 导航栏 视频 List
export const queryVideoPageList = (data)=>{
  return getInterface.post(`${prefixUrl}queryVideoPageList`, data);
}
// 工作台 分组新增
export const putWorkbenchGroup = (data)=>{
  return getInterface.post(`${prefixUrl}putWorkbenchGroup`, data);
}
// 工作台 分组List
export const queryWorkbenchGroup = (data)=>{
  return getInterface.post(`${prefixUrl}queryWorkbenchGroup`, data);
}
// 工作台 分组详情
export const queryAnnotationGroup = (data)=>{
  return getInterface.post(`${prefixUrl}queryAnnotationGroup`, data);
}
// 用户曝光数据
export const queryExposureStatisticsByTimeRange = (data)=>{
  return getInterface.post(`${prefixUrl}queryExposureStatisticsByTimeRange`, data);
}
// 下载曝光数据
export const downloadExposureStatistics = (data)=>{
  return getInterface.post(`${prefixUrl}downloadExposureStatistics`, data);
}
// 默认底图&&自定义底图
export const queryWorkbenchCorrelationBaseMap = (data)=>{
  return getInterface.post(`${prefixUrl}queryWorkbenchCorrelationBaseMap`, data);
}
// 默认底图List
export const queryFixedBaseMap = (data)=>{
  return getInterface.post(`${prefixUrl}queryFixedBaseMap`, data);
}
// 工作台绑定底图
export const workbenchBindBaseMap = (data)=>{
  return getInterface.post(`${prefixUrl}workbenchBindBaseMap`, data);
}
// 前置标注更换底图
export const moveAnnotation = (data)=>{
  return getInterface.post(`${prefixUrl}moveAnnotation`, data);
}
// 底图对应的AI解读内容
export const queryOtherDataByMap = (data)=>{
  return getInterface.post(`${prefixUrl}queryOtherDataByMap/${data}`, {});
}